

// import React, { useState } from 'react';

// const DisclaimerScreen = ({ onAccept, onDecline }) => {
//   const [accepted, setAccepted] = useState(false);
//   const [hasReadTerms, setHasReadTerms] = useState(false);
  
//   const handleAccept = () => {
//     setAccepted(true);
//     if (onAccept) onAccept();
//   };
  
//   const handleDecline = () => {
//     if (onDecline) onDecline();
//   };

//   // Track scroll to bottom of terms
//   const handleScroll = (e) => {
//     const { scrollTop, scrollHeight, clientHeight } = e.target;
//     // If scrolled to bottom (with small buffer)
//     if (scrollHeight - scrollTop <= clientHeight + 10) {
//       setHasReadTerms(true);
//     }
//   };
  
//   return (
//     <div className="disclaimer-container">
//       <h1 className="disclaimer-title">END USER LICENSE AGREEMENT</h1>
//       <h2 className="disclaimer-subtitle">PAWS AI MOBILE APPLICATION</h2>
//       <h3 className="disclaimer-focus">Dog Nutrition & Feeding Plan App</h3>
      
//       <div className="disclaimer-scroll-container" onScroll={handleScroll}>
//         <p className="disclaimer-date-text">
//           <strong>Effective Date: </strong>
//           {new Date().toLocaleDateString()}
//         </p>
        
//         <div className="disclaimer-section">
//           <h3 className="disclaimer-section-title">1. Parties</h3>
//           <p className="disclaimer-paragraph">
//             This Agreement is between <strong>OnePace LLC</strong> ("Licensor"), 
//             a Texas limited liability company with its principal office at 5900 Balcones Drive, Austin, Texas, 
//             and the end user ("You") of the Paws AI mobile application ("App").
//           </p>
//         </div>
        
//         <div className="disclaimer-section">
//           <h3 className="disclaimer-section-title">2. Binding Acceptance</h3>
//           <p className="disclaimer-paragraph">
//             By installing or using the App, You irrevocably agree to these terms. 
//             Corporate users warrant signatory authority through board resolution or equivalent documentation.
//           </p>
//         </div>
        
//         <div className="disclaimer-section">
//           <h3 className="disclaimer-section-title">3. License Restrictions</h3>
//           <p className="disclaimer-paragraph">
//             <strong>Granted Rights:</strong>
//           </p>
//           <ul className="disclaimer-list">
//             <li>Non-commercial use only for dog owners</li>
//             <li>Temporary access per subscription tier</li>
//           </ul>
//           <p className="disclaimer-paragraph">
//             <strong>Commercial Use: </strong>
//             Requires written authorization + Commercial License ($299+/month)
//           </p>
//         </div>
        
//         <div className="disclaimer-section">
//           <h3 className="disclaimer-section-title">4. Absolute Prohibitions</h3>
//           <p className="disclaimer-paragraph">
//             You expressly agree NOT to:
//           </p>
//           <ul className="disclaimer-list">
//             <li>Reverse-engineer nutritional algorithms</li>
//             <li>Create derivative meal planning systems</li>
//             <li>Use AI outputs for pharmaceutical development</li>
//             <li>Share accounts across veterinary practices</li>
//           </ul>
//         </div>
        
//         <div className="disclaimer-section">
//           <h3 className="disclaimer-section-title">5. Veterinary Disclaimer (§5.2-5.4 Critical)</h3>
//           <h4 className="disclaimer-subsection-title">5.1 Not Medical Advice</h4>
//           <p className="disclaimer-paragraph">
//             The App provides <u>general canine nutritional guidelines only</u> and expressly excludes:
//           </p>
//           <ul className="disclaimer-list">
//             <li>Puppy growth formulas</li>
//             <li>Medical condition management</li>
//             <li>Prescription diet alternatives</li>
//           </ul>
          
//           <h4 className="disclaimer-subsection-title">5.2 Mandatory Verifications</h4>
//           <p className="disclaimer-paragraph">
//             You must:
//           </p>
//           <ol className="disclaimer-ordered-list">
//             <li>Obtain written veterinary approval before implementation</li>
//             <li>Conduct bi-weekly health checkups during dietary transitions</li>
//             <li>Maintain malpractice insurance if used professionally</li>
//           </ol>
          
//           <h4 className="disclaimer-subsection-title">5.3 Liability Exclusion</h4>
//           <p className="disclaimer-paragraph">
//             Licensor disclaims all responsibility for:
//           </p>
//           <ul className="disclaimer-list">
//             <li>Adverse reactions from unverified meal plans</li>
//             <li>Nutritional deficiencies exceeding 10% of AAFCO standards</li>
//             <li>Third-party interpretation errors</li>
//           </ul>
          
//           <h4 className="disclaimer-subsection-title">5.4 Emergency Protocol</h4>
//           <p className="disclaimer-paragraph">
//             Immediately discontinue use and contact emergency services if dog exhibits:
//           </p>
//           <ul className="disclaimer-list">
//             <li>Vomiting/diarrhea lasting &gt;12hrs</li>
//             <li>Lethargy/uncoordinated movement</li>
//             <li>Allergic reactions</li>
//           </ul>
//         </div>
        
//         <div className="disclaimer-section">
//           <h3 className="disclaimer-section-title">6. Financial Terms</h3>
//           <p className="disclaimer-paragraph">
//             <strong>Subscriptions:</strong>
//           </p>
//           <ul className="disclaimer-list">
//             <li>Auto-renewal unless canceled 72hrs pre-cycle</li>
//             <li>14-day trial requires veterinary license verification</li>
//           </ul>
//           <p className="disclaimer-paragraph">
//             <strong>Refunds: </strong>
//             Prohibited except under Texas Business & Commerce Code §2.725
//           </p>
//         </div>
        
//         <div className="disclaimer-section">
//           <h3 className="disclaimer-section-title">7. Intellectual Property</h3>
//           <p className="disclaimer-paragraph">
//             <strong>Ownership:</strong>
//           </p>
//           <ul className="disclaimer-list">
//             <li>Full rights to AI models and nutritional databases</li>
//             <li>User recipes become Licensor's training data</li>
//           </ul>
//           <p className="disclaimer-paragraph">
//             <strong>Penalties: </strong>
//             $150,000 minimum damages for unauthorized commercialization
//           </p>
//         </div>
        
//         <div className="disclaimer-section">
//           <h3 className="disclaimer-section-title">8. Data Protections</h3>
//           <ul className="disclaimer-list">
//             <li>Dog health data encrypted via AES-256</li>
//             <li>Right to disclose to veterinary authorities if abuse suspected</li>
//             <li>EU users: DPO contact@dpo.paws.ai</li>
//           </ul>
//         </div>
        
//         <div className="disclaimer-section">
//           <h3 className="disclaimer-section-title">9. Liability Caps</h3>
//           <p className="disclaimer-paragraph">
//             <strong>Total Liability: </strong>≤ 6 months subscription fees paid
//           </p>
//           <p className="disclaimer-paragraph">
//             <strong>Excluded Claims:</strong>
//           </p>
//           <ul className="disclaimer-list">
//             <li>Dog mortality</li>
//             <li>Specialty food costs</li>
//             <li>Diagnostic expenses</li>
//             <li>Emotional distress</li>
//           </ul>
//         </div>
        
//         <div className="disclaimer-section">
//           <h3 className="disclaimer-section-title">10. Dispute Resolution</h3>
//           <ul className="disclaimer-list">
//             <li>Mandatory arbitration via AAA Rules</li>
//             <li>Venue: Travis County, TX</li>
//             <li>No class actions</li>
//             <li>Prevailing party recovers legal fees</li>
//           </ul>
//         </div>
        
//         <div className="disclaimer-section">
//           <h3 className="disclaimer-section-title">11. Termination</h3>
//           <p className="disclaimer-paragraph">
//             Licensor may disable access immediately for:
//           </p>
//           <ul className="disclaimer-list">
//             <li>3+ veterinary complaints</li>
//             <li>Unauthorized prescription claims</li>
//             <li>FDA/FTC investigation triggers</li>
//           </ul>
//         </div>
        
//         <div className="disclaimer-section">
//           <h3 className="disclaimer-section-title">12. Updates & Contact</h3>
//           <ul className="disclaimer-list">
//             <li>30-day notice for material changes</li>
//             <li>Continued use = acceptance</li>
//           </ul>
//           <p className="disclaimer-paragraph">
//             <strong>Legal Inquiries:</strong>
//           </p>
//           <p className="disclaimer-contact">
//             OnePace LLC<br />
//             5900 Balcones Dr, Austin TX<br />
//             emma@paws.lol
//           </p>
//         </div>
//       </div>
      
 
      
//       <style jsx>{`
//         .disclaimer-container {
//           font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
//           padding: 16px;
//           max-width: 100%;
//           margin: 0 auto;
//           background-color: #fff;
//           height: 100%;
//           display: flex;
//           flex-direction: column;
//         }
        
//         .disclaimer-title {
//           font-size: 20px;
//           text-align: center;
//           margin-bottom: 8px;
//           color: #333;
//         }
        
//         .disclaimer-subtitle {
//           font-size: 16px;
//           text-align: center;
//           margin-bottom: 16px;
//           color: #666;
//         }
        
//         .disclaimer-focus {
//           font-size: 14px;
//           text-align: center;
//           margin-bottom: 16px;
//           color: #0066cc;
//         }
        
//         .disclaimer-scroll-container {
//           flex: 1;
//           overflow-y: auto;
//           border: 1px solid #ddd;
//           padding: 16px;
//           margin-bottom: 16px;
//           background-color: #f9f9f9;
//           border-radius: 8px;
//           -webkit-overflow-scrolling: touch;
//         }
        
//         .disclaimer-section {
//           margin-bottom: 16px;
//         }
        
//         .disclaimer-section-title {
//           font-size: 16px;
//           margin-bottom: 8px;
//           color: #333;
//         }
        
//         .disclaimer-subsection-title {
//           font-size: 14px;
//           margin-bottom: 8px;
//           color: #444;
//         }
        
//         .disclaimer-paragraph {
//           font-size: 14px;
//           line-height: 1.5;
//           margin-bottom: 8px;
//           color: #333;
//         }
        
//         .disclaimer-list, .disclaimer-ordered-list {
//           font-size: 14px;
//           line-height: 1.5;
//           margin-left: 24px;
//           margin-bottom: 8px;
//           color: #333;
//         }
        
//         .disclaimer-contact {
//           font-size: 14px;
//           line-height: 1.5;
//           margin-bottom: 8px;
//           color: #666;
//         }
        
//         .disclaimer-date-text {
//           font-size: 14px;
//           margin-bottom: 16px;
//           color: #666;
//         }
        
//         .disclaimer-checkbox-container {
//           margin-bottom: 16px;
//         }
        
//         .disclaimer-checkbox-label {
//           display: flex;
//           align-items: center;
//           font-size: 14px;
//           color: #333;
//         }
        
//         .disclaimer-checkbox {
//           margin-right: 8px;
//           min-width: 20px;
//           min-height: 20px;
//         }
        
//         .disclaimer-buttons-container {
//           display: flex;
//           justify-content: space-between;
//           gap: 16px;
//           margin-top: 8px;
//         }
        
//         .disclaimer-button {
//           flex: 1;
//           padding: 12px;
//           border-radius: 8px;
//           font-size: 16px;
//           font-weight: bold;
//           border: none;
//           cursor: pointer;
//           min-height: 48px; /* Minimum touch target size */
//         }
        
//         .disclaimer-decline-button {
//           background-color: #f0f0f0;
//           color: #666;
//         }
        
//         .disclaimer-accept-button {
//           background-color: #0066cc;
//           color: white;
//         }
        
//         .disclaimer-button-disabled {
//           opacity: 0.5;
//           cursor: not-allowed;
//         }
        
//         @media (max-width: 480px) {
//           .disclaimer-title {
//             font-size: 18px;
//           }
          
//           .disclaimer-subtitle {
//             font-size: 14px;
//           }
          
//           .disclaimer-section-title {
//             font-size: 15px;
//           }
          
//           .disclaimer-paragraph,
//           .disclaimer-list,
//           .disclaimer-ordered-list,
//           .disclaimer-date-text,
//           .disclaimer-checkbox-label {
//             font-size: 13px;
//           }
          
//           .disclaimer-button {
//             font-size: 14px;
//             padding: 10px;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default DisclaimerScreen;

import React, { useState } from 'react';

const DisclaimerScreen = ({ onAccept, onDecline }) => {
  const [hasReadTerms, setHasReadTerms] = useState(false);
  
  const handleAccept = () => {
    if (onAccept) onAccept();
  };
  
  const handleDecline = () => {
    if (onDecline) onDecline();
  };

  // Track scroll to bottom of terms
  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    // If scrolled to bottom (with small buffer)
    if (scrollHeight - scrollTop <= clientHeight + 10) {
      setHasReadTerms(true);
    }
  };
  
  return (
    <div className="disclaimer-container">
      <h1 className="disclaimer-title">END USER LICENSE AGREEMENT</h1>
      <h2 className="disclaimer-subtitle">PAWS AI MOBILE APPLICATION</h2>
      <h3 className="disclaimer-focus">Dog Nutrition & Feeding Plan App</h3>
      
      <div className="disclaimer-scroll-container" onScroll={handleScroll}>
        <p className="disclaimer-date-text">
          <strong>Effective Date: </strong>
          {new Date().toLocaleDateString()}
        </p>
        
        <div className="disclaimer-section">
          <h3 className="disclaimer-section-title">1. Parties</h3>
          <p className="disclaimer-paragraph">
            This Agreement is between <strong>OnePace LLC</strong> ("Licensor"), 
            a Texas limited liability company with its principal office at 5900 Balcones Drive, Austin, Texas, 
            and the end user ("You") of the Paws AI mobile application ("App").
          </p>
        </div>
        
        <div className="disclaimer-section">
          <h3 className="disclaimer-section-title">2. Binding Acceptance</h3>
          <p className="disclaimer-paragraph">
            By installing or using the App, You irrevocably agree to these terms. 
            Corporate users warrant signatory authority through board resolution or equivalent documentation.
          </p>
          <p className="disclaimer-paragraph disclaimer-important">
            <strong>BY CLICKING "ACCEPT" OR BY USING THE APP IN ANY WAY, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY ALL TERMS, CONDITIONS, AND NOTICES CONTAINED IN THIS AGREEMENT. IF YOU DO NOT AGREE, DO NOT USE THE APP.</strong>
          </p>
        </div>
        
        <div className="disclaimer-section">
          <h3 className="disclaimer-section-title">3. License Restrictions</h3>
          <p className="disclaimer-paragraph">
            <strong>Granted Rights:</strong>
          </p>
          <ul className="disclaimer-list">
            <li>Non-commercial use only for dog owners</li>
            <li>Temporary access per subscription tier</li>
          </ul>
          <p className="disclaimer-paragraph">
            <strong>Commercial Use: </strong>
            Requires written authorization + Commercial License ($299+/month)
          </p>
        </div>
        
        <div className="disclaimer-section">
          <h3 className="disclaimer-section-title">4. Absolute Prohibitions</h3>
          <p className="disclaimer-paragraph">
            You expressly agree NOT to:
          </p>
          <ul className="disclaimer-list">
            <li>Reverse-engineer nutritional algorithms</li>
            <li>Create derivative meal planning systems</li>
            <li>Use AI outputs for pharmaceutical development</li>
            <li>Share accounts across veterinary practices</li>
          </ul>
        </div>
        
        <div className="disclaimer-section disclaimer-critical-section">
          <h3 className="disclaimer-section-title">5. Veterinary Disclaimer (§5.2-5.4 Critical)</h3>
          <h4 className="disclaimer-subsection-title">5.1 Not Medical Advice</h4>
          <p className="disclaimer-paragraph">
            The App provides <u>general canine nutritional guidelines only</u> and expressly excludes:
          </p>
          <ul className="disclaimer-list">
            <li>Puppy growth formulas</li>
            <li>Medical condition management</li>
            <li>Prescription diet alternatives</li>
          </ul>
          <p className="disclaimer-paragraph disclaimer-important">
            <strong>EDUCATIONAL PURPOSE ONLY:</strong> This App and all content, information, suggestions, meal plans, and feeding guidelines contained herein are provided FOR EDUCATIONAL AND INFORMATIONAL PURPOSES ONLY and do not constitute veterinary advice, medical diagnosis, or treatment recommendations for your dog. The App is not a substitute for professional veterinary care.
          </p>
          
          <h4 className="disclaimer-subsection-title">5.2 Mandatory Verifications</h4>
          <p className="disclaimer-paragraph">
            You must:
          </p>
          <ol className="disclaimer-ordered-list">
            <li>Obtain written veterinary approval before implementation</li>
            <li>Conduct bi-weekly health checkups during dietary transitions</li>
            <li>Maintain malpractice insurance if used professionally</li>
          </ol>
          <p className="disclaimer-paragraph disclaimer-important">
            <strong>USER ACKNOWLEDGMENT:</strong> By using the App, you expressly acknowledge and agree that implementing any feeding plan, recipe, or nutritional guideline without prior veterinary consultation is done entirely at your own risk. You assume full responsibility for any consequences that may arise from using the information provided by the App.
          </p>
          
          <h4 className="disclaimer-subsection-title">5.3 Liability Exclusion</h4>
          <p className="disclaimer-paragraph">
            Licensor disclaims all responsibility for:
          </p>
          <ul className="disclaimer-list">
            <li>Adverse reactions from unverified meal plans</li>
            <li>Nutritional deficiencies exceeding 10% of AAFCO standards</li>
            <li>Third-party interpretation errors</li>
          </ul>
          <p className="disclaimer-paragraph disclaimer-important">
            <strong>COMPREHENSIVE WAIVER:</strong> To the maximum extent permitted by applicable law, you hereby release, waive, discharge, and covenant not to sue Licensor, its officers, employees, agents, subsidiaries, affiliates, contractors, and licensors from any and all liability, claims, demands, actions, and causes of action whatsoever arising out of or related to any loss, damage, injury, illness, death, or other harm suffered by your dog or any other animal in connection with the use of the App or implementation of any nutritional guidance derived therefrom, regardless of whether such harm results from Licensor's negligence or error in the App's algorithms, recommendations, or content.
          </p>
          
          <h4 className="disclaimer-subsection-title">5.4 Emergency Protocol</h4>
          <p className="disclaimer-paragraph">
            Immediately discontinue use and contact emergency services if dog exhibits:
          </p>
          <ul className="disclaimer-list">
            <li>Vomiting/diarrhea lasting &gt;12hrs</li>
            <li>Lethargy/uncoordinated movement</li>
            <li>Allergic reactions</li>
          </ul>
          <p className="disclaimer-paragraph disclaimer-important">
            <strong>NO CAUSATION PRESUMPTION:</strong> The appearance of any adverse health condition in your dog following or during use of the App shall not create any presumption or inference that the App caused or contributed to such condition. You acknowledge that numerous external factors unrelated to the App may cause similar symptoms, and by using the App, you waive any claim that temporally associated adverse events were caused by the App absent scientifically valid evidence establishing direct causation.
          </p>
        </div>
        
        <div className="disclaimer-section">
          <h3 className="disclaimer-section-title">6. Financial Terms</h3>
          <p className="disclaimer-paragraph">
            <strong>Subscriptions:</strong>
          </p>
          <ul className="disclaimer-list">
            <li>Auto-renewal unless canceled 72hrs pre-cycle</li>
            <li>14-day trial requires veterinary license verification</li>
          </ul>
          <p className="disclaimer-paragraph">
            <strong>Refunds: </strong>
            Prohibited except under Texas Business & Commerce Code §2.725
          </p>
        </div>
        
        <div className="disclaimer-section">
          <h3 className="disclaimer-section-title">7. Intellectual Property</h3>
          <p className="disclaimer-paragraph">
            <strong>Ownership:</strong>
          </p>
          <ul className="disclaimer-list">
            <li>Full rights to AI models and nutritional databases</li>
            <li>User recipes become Licensor's training data</li>
          </ul>
          <p className="disclaimer-paragraph">
            <strong>Penalties: </strong>
            $150,000 minimum damages for unauthorized commercialization
          </p>
        </div>
        
        <div className="disclaimer-section">
          <h3 className="disclaimer-section-title">8. Data Protections</h3>
          <ul className="disclaimer-list">
            <li>Dog health data encrypted via AES-256</li>
            <li>Right to disclose to veterinary authorities if abuse suspected</li>
            <li>EU users: DPO contact@dpo.paws.ai</li>
          </ul>
        </div>
        
        <div className="disclaimer-section">
          <h3 className="disclaimer-section-title">9. Liability Caps</h3>
          <p className="disclaimer-paragraph">
            <strong>Total Liability: </strong>≤ 6 months subscription fees paid
          </p>
          <p className="disclaimer-paragraph">
            <strong>Excluded Claims:</strong>
          </p>
          <ul className="disclaimer-list">
            <li>Dog mortality</li>
            <li>Specialty food costs</li>
            <li>Diagnostic expenses</li>
            <li>Emotional distress</li>
          </ul>
          <p className="disclaimer-paragraph disclaimer-important">
            <strong>INDEMNIFICATION:</strong> You agree to indemnify, defend, and hold harmless Licensor and its officers, directors, employees, agents, affiliates, successors, and assigns from and against any and all losses, damages, liabilities, deficiencies, actions, judgments, settlements, interest, awards, penalties, fines, costs, or expenses of whatever kind (including reasonable attorneys' fees) arising from or relating to: (a) your use of the App; (b) your implementation of any nutritional guidance derived from the App; (c) any dog illness, injury, or death allegedly related to your use of the App; (d) any claim that your use of the App caused harm to a third party; and (e) your breach of this Agreement.
          </p>
        </div>
        
        <div className="disclaimer-section">
          <h3 className="disclaimer-section-title">10. Dispute Resolution</h3>
          <ul className="disclaimer-list">
            <li>Mandatory arbitration via AAA Rules</li>
            <li>Venue: Travis County, TX</li>
            <li>No class actions</li>
            <li>Prevailing party recovers legal fees</li>
          </ul>
          <p className="disclaimer-paragraph disclaimer-important">
            <strong>EVIDENCE STANDARD:</strong> In any dispute arising from or related to the App, you acknowledge and agree that correlation between use of the App and any adverse health outcome shall not, by itself, constitute evidence of causation without additional scientifically valid evidence establishing a direct causal relationship to a reasonable degree of medical certainty as would be required in a court of law.
          </p>
        </div>
        
        <div className="disclaimer-section">
          <h3 className="disclaimer-section-title">11. Termination</h3>
          <p className="disclaimer-paragraph">
            Licensor may disable access immediately for:
          </p>
          <ul className="disclaimer-list">
            <li>3+ veterinary complaints</li>
            <li>Unauthorized prescription claims</li>
            <li>FDA/FTC investigation triggers</li>
          </ul>
        </div>
        
        <div className="disclaimer-section">
          <h3 className="disclaimer-section-title">12. Updates & Contact</h3>
          <ul className="disclaimer-list">
            <li>30-day notice for material changes</li>
            <li>Continued use = acceptance</li>
          </ul>
          <p className="disclaimer-paragraph">
            <strong>Legal Inquiries:</strong>
          </p>
          <p className="disclaimer-contact">
            OnePace LLC<br />
            5900 Balcones Dr, Austin TX<br />
            emma@paws.lol
          </p>
        </div>
        
        <div className="disclaimer-section">
          <h3 className="disclaimer-section-title">13. Educational Nature of App</h3>
          <p className="disclaimer-paragraph disclaimer-important">
            <strong>EDUCATIONAL TOOL ONLY:</strong> You expressly acknowledge and agree that the App is provided as an educational resource only and does not create a veterinarian-client-patient relationship. The App does not provide individualized medical advice and is not a substitute for professional veterinary care. All content, information, meal plans, recipes, and nutritional guidelines are provided for general informational and educational purposes only.
          </p>
          <p className="disclaimer-paragraph disclaimer-important">
            <strong>USER RESPONSIBILITY:</strong> You assume full responsibility for consulting with a licensed veterinarian regarding your dog's specific nutritional needs before implementing any feeding plan or nutritional guidance obtained from the App. Individual dogs may have unique health conditions, allergies, sensitivities, or nutritional requirements that cannot be accounted for by generalized recommendations.
          </p>
        </div>
        
        <div className="disclaimer-section">
          <h3 className="disclaimer-section-title">14. Assumption of Risk</h3>
          <p className="disclaimer-paragraph disclaimer-important">
            <strong>VOLUNTARY ASSUMPTION OF RISK:</strong> You acknowledge that altering your dog's diet carries inherent risks, including but not limited to gastrointestinal distress, allergic reactions, nutritional imbalances, and other adverse health effects. By using the App, you voluntarily and knowingly assume all such risks, both known and unknown, associated with implementing any nutritional guidance derived from the App, even if arising from the negligence of Licensor.
          </p>
          <p className="disclaimer-paragraph disclaimer-important">
            <strong>NO REPRESENTATIONS OR WARRANTIES:</strong> Licensor makes no representations or warranties regarding the accuracy, completeness, reliability, or efficacy of any content provided through the App. The nutritional algorithms and recommendations are based on general principles and publicly available research that may not account for the specific needs of your dog.
          </p>
        </div>
      </div>
      
      
      
      <style jsx>{`
        .disclaimer-container {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
          padding: 16px;
          max-width: 100%;
          margin: 0 auto;
          background-color: #fff;
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        
        .disclaimer-title {
          font-size: 20px;
          text-align: center;
          margin-bottom: 8px;
          color: #333;
        }
        
        .disclaimer-subtitle {
          font-size: 16px;
          text-align: center;
          margin-bottom: 8px;
          color: #666;
        }
        
        .disclaimer-focus {
          font-size: 14px;
          text-align: center;
          margin-bottom: 8px;
          color: #0066cc;
        }
        
        .disclaimer-educational {
          font-size: 14px;
          text-align: center;
          margin-bottom: 16px;
          color: #cc0000;
          font-weight: bold;
          text-transform: uppercase;
          border-top: 1px solid #cc0000;
          border-bottom: 1px solid #cc0000;
          padding: 8px 0;
        }
        
        .disclaimer-scroll-container {
          flex: 1;
          overflow-y: auto;
          border: 1px solid #ddd;
          padding: 16px;
          margin-bottom: 16px;
          background-color: #f9f9f9;
          border-radius: 8px;
          -webkit-overflow-scrolling: touch;
        }
        
        .disclaimer-section {
          margin-bottom: 16px;
        }
        
        .disclaimer-critical-section {
          border: 1px solid #cc0000;
          padding: 8px;
          border-radius: 4px;
          background-color: #fff6f6;
        }
        
        .disclaimer-important {
          background-color: #fff9e6;
          padding: 8px;
          border-left: 3px solid #ffcc00;
          margin-top: 8px;
        }
        
        .disclaimer-section-title {
          font-size: 16px;
          margin-bottom: 8px;
          color: #333;
        }
        
        .disclaimer-subsection-title {
          font-size: 14px;
          margin-bottom: 8px;
          color: #444;
        }
        
        .disclaimer-paragraph {
          font-size: 14px;
          line-height: 1.5;
          margin-bottom: 8px;
          color: #333;
        }
        
        .disclaimer-list, .disclaimer-ordered-list {
          font-size: 14px;
          line-height: 1.5;
          margin-left: 24px;
          margin-bottom: 8px;
          color: #333;
        }
        
        .disclaimer-contact {
          font-size: 14px;
          line-height: 1.5;
          margin-bottom: 8px;
          color: #666;
        }
        
        .disclaimer-date-text {
          font-size: 14px;
          margin-bottom: 16px;
          color: #666;
        }
        
        .disclaimer-buttons-container {
          display: flex;
          justify-content: space-between;
          gap: 16px;
          margin-top: 8px;
        }
        
        .disclaimer-button {
          flex: 1;
          padding: 12px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: bold;
          border: none;
          cursor: pointer;
          min-height: 48px; /* Minimum touch target size */
        }
        
        .disclaimer-decline-button {
          background-color: #f0f0f0;
          color: #666;
        }
        
        .disclaimer-accept-button {
          background-color: #0066cc;
          color: white;
        }
        
        .disclaimer-button-disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        
        @media (max-width: 480px) {
          .disclaimer-title {
            font-size: 18px;
          }
          
          .disclaimer-subtitle {
            font-size: 14px;
          }
          
          .disclaimer-section-title {
            font-size: 15px;
          }
          
          .disclaimer-paragraph,
          .disclaimer-list,
          .disclaimer-ordered-list,
          .disclaimer-date-text {
            font-size: 13px;
          }
          
          .disclaimer-button {
            font-size: 14px;
            padding: 10px;
          }
        }
      `}</style>
    </div>
  );
};

export default DisclaimerScreen;